import axios from "axios";
import qs from "qs";
import Api from "@/api/user";
import {
  getToken,
  clearUserInfo,
  getRefreshToken,
  storeUserInfo,
} from "@/libs/utils";

const loginFilterList = ["/api/app/outsource/operator/sendValidateCode"];
let isRefreshToken = false;

// 需要把pageSize pageNo 放在把bady里
const pageList = ["/api/app/outsource/operator/findListByOrg"];
let requestList = []; // 请求队列

class HttpRequest {
  constructor(configs) {
    this.baseUrl = configs.baseUrl + "/admin-api";
  }

  getInsideConfig() {
    const tokenHeader = {
      "Tenant-id": "1",
    };
    const token = getToken();
    if (token) {
      tokenHeader["Authorization"] = `Bearer ${token}`;
    }

    const config = {
      baseURL: this.baseUrl,
      defaults: {
        withCredentials: true,
      },
      // transformRequest: [data => qs.stringify(data)],
      headers: {
        post: {
          "Content-Type": "application/json;",
        },
        platform: "FINANCE_OUTSOURCE_APP",
        ...tokenHeader,
      },
    };
    return config;
  }

  // 未登录 无权限
  async doLogin() {
    const pathName = window.location.pathname;
    if (pathName == "/login") return;
    clearUserInfo();
    window.location.href = "/login";
  }

  interceptors(instance, options) {
    // 请求拦截
    instance.interceptors.request.use(
      (config) => {
        if (
          config.headers["Content-Type"] === "application/x-www-form-urlencoded"
        ) {
          config.transformRequest = [(data) => qs.stringify(data)];
        }
        // 接口-登录过滤
        loginFilterList.includes(config.url) &&
          delete config.headers.Authorization;

        const MOVE_TO_PARAMS_KEY = ["pageNo", "pageSize"];
        if (!pageList.includes(config.url)) {
          if (config.data) {
            config.params = config.params || {};
            for (const key of MOVE_TO_PARAMS_KEY) {
              if (typeof config.data[key] !== "undefined") {
                config.params[key] = config.data[key];
                delete config.data[key];
              }
            }
            if (config.method.toLocaleUpperCase() == "GET") {
              config.params = { ...config.params, ...(config.data || {}) };
            }
          }
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // 响应拦截
    instance.interceptors.response.use(
      async (res) => {
        if ([401].includes(res.data.code)) {
          let refreshToken = getRefreshToken();
          if (!isRefreshToken) {
            isRefreshToken = true;
            if (!refreshToken) {
              this.doLogin();
            }
            try {
              let res = await Api.refreshToken(refreshToken);
              storeUserInfo(res.data);
              const user = await Api.baseInfo();
              storeUserInfo({ ...res.data, ...user });
              options.headers.Authorization = `Bearer ${getToken()}`;
              requestList.forEach((cb) => {
                cb();
              });
              requestList = [];
              return this.request(options);
            } catch (error) {
              this.doLogin();
            } finally {
              requestList = [];
              isRefreshToken = false;
            }
          } else {
            return new Promise((resolve) => {
              options.headers.Authorization = `Bearer ${getToken()}`;
              requestList.push(() => {
                resolve(this.request(options));
              });
            });
          }
        }
        if (res.data.code !== 0) {
          throw res.data.msg;
        }
        return res.data;
      },
      (error) => {
        if (error.response) {
          if (error.response.data.msg) {
            throw error.response.data.msg;
          } else {
            throw "网络不佳~请稍后重试~";
          }
        }
        throw "网络不佳~请稍后重试~";
      }
    );
  }

  request(options) {
    const instance = axios.create();
    options = Object.assign(
      this.getInsideConfig(),
      {
        method: "POST",
      },
      options
    );
    options.headers = {
      ...options.headers,
      "Tenant-id": "1",
    };
    this.interceptors(instance, options);
    return instance(options);
  }
}
export default HttpRequest;
